import { cn } from '@/utils/cn';

export function Avatar({ name = 'U', size = 'md', className }) {
  const initials = String(name)
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');

  const sizes = {
    sm: 'h-8 w-8 text-xs',
    md: 'h-9 w-9 text-sm',
    lg: 'h-11 w-11 text-base',
  };

  return (
    <div
      className={cn(
        'inline-flex items-center justify-center rounded-full bg-[var(--primary)]/15 font-semibold text-[var(--primary)]',
        sizes[size],
        className,
      )}
      aria-hidden
    >
      {initials || 'U'}
    </div>
  );
}
